var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnime = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Kawaii-Manga-Ninja-Naruto-Shippuden--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Kawaii Manga Ninja Naruto Shippuden Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21 12v-0.82a1.45 1.45 0 0 0 0 -0.29 9 9 0 0 0 -5.29 -5.29A10 10 0 0 0 12 4.93a10.36 10.36 0 0 0 -3.56 0.65 0.88 0.88 0 0 0 -0.22 0.1 8.86 8.86 0 0 0 -5.16 5.21 1 1 0 0 0 -0.06 0.33V12a3.49 3.49 0 0 0 0.08 7 6.1 6.1 0 0 0 6 5h5.76a6.1 6.1 0 0 0 6 -5 3.49 3.49 0 0 0 0.16 -7Zm-6.74 -4.8v1.87a42.59 42.59 0 0 0 -4.52 0V7.24A9.45 9.45 0 0 1 12 6.93a9.38 9.38 0 0 1 2.26 0.31Zm6.18 9.8H20a1 1 0 0 0 -1 1 4.07 4.07 0 0 1 -4.12 4H9.12A4.07 4.07 0 0 1 5 18a1 1 0 0 0 -1 -1h-0.44a1.5 1.5 0 1 1 0 -3H4a1 1 0 0 0 1 -1v-1a17.93 17.93 0 0 1 3.54 -0.8l0.29 0h0.07a40 40 0 0 1 6.19 0h0.08l0.29 0a18.53 18.53 0 0 1 3.42 0.76l0.1 0v1a1 1 0 0 0 1 1h0.44a1.5 1.5 0 1 1 0 3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 15H7a1 1 0 0 0 0 2h0.75a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 18H7a1 1 0 0 0 0 2h0.75a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15h-0.75a1 1 0 0 0 0 2H17a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18h-0.75a1 1 0 0 0 0 2H17a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.94 16.92 -0.93 0.63 -1 -0.63A1 1 0 0 0 10 18.59l1.51 1a1 1 0 0 0 1.11 0l1.49 -1a1 1 0 0 0 -1.12 -1.67Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.74 14a1 1 0 0 0 -0.26 -1.39 3.08 3.08 0 0 0 -2.77 -0.4 1 1 0 0 0 -0.55 1.27 1 1 0 0 0 1.27 0.6 1.05 1.05 0 0 1 0.92 0.18 1 1 0 0 0 1.39 -0.26Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.57 14a1 1 0 0 0 0.72 -1.87 3.08 3.08 0 0 0 -2.77 0.4 1 1 0 0 0 0.57 1.83 1 1 0 0 0 0.56 -0.18 1.09 1.09 0 0 1 0.92 -0.18Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.78 9.32a1 1 0 0 0 1.27 0.68 1 1 0 0 0 0.63 -1.26l-0.05 -0.17 0.81 -0.81a1 1 0 0 0 0.29 -0.62l0.17 -1.97L6.07 5a1 1 0 0 0 0.85 -0.65l0.66 -1.82 2.57 0.92a1 1 0 0 0 1 -0.23l0.82 -0.8 0.8 0.8a1 1 0 0 0 1 0.23l2.57 -0.92 0.66 1.82a1 1 0 0 0 0.85 0.65l2.17 0.18 0.17 1.92a1 1 0 0 0 0.29 0.62l0.81 0.81 -0.05 0.17a1 1 0 0 0 0.7 1.3 0.89 0.89 0 0 0 0.32 0.05 1 1 0 0 0 0.95 -0.68l0.25 -0.76a1 1 0 0 0 -0.25 -1l-1 -1L22 4.16a1 1 0 0 0 -0.91 -0.91l-2.36 -0.2L18 0.91a1 1 0 0 0 -1.28 -0.6l-2.91 1L12.7 0.29a1 1 0 0 0 -1.4 0l-1.07 1.05L7.32 0.31A1 1 0 0 0 6 0.91l-0.74 2.14 -2.36 0.2a1 1 0 0 0 -0.9 0.91l-0.23 2.39 -1 1a1 1 0 0 0 -0.25 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnime);
export default ForwardRef;